import { useReveal } from "../hooks/useReveal";

const IMAGES = [
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-real-estate-17/artifacts/oe057y9a_Founder.webp",
    tag: "01 · Leadership",
    title: "Grounded in vision",
    caption:
      "Every mandate we take on is guided directly by our founder — a personal approach rarely available in Dubai's fragmented advisory market.",
  },
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-real-estate-17/artifacts/movn9n79_Gemini_Generated_Image_tbuhp9tbuhp9tbuh.webp",
    tag: "02 · Consultation",
    title: "Curated on your terms",
    caption:
      "We begin with a private consultation — understanding lifestyle, timelines and return objectives before ever presenting a single property.",
  },
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_premium-real-estate-17/artifacts/rkjidagr_Gemini_Generated_Image_4zwda64zwda64zwd.webp",
    tag: "03 · Advisory",
    title: "From shortlist to signing",
    caption:
      "A concise shortlist, full transparency on price and payment terms, and end-to-end support through reservation, contracts and handover.",
  },
];

export const Experience = () => {
  const ref = useReveal();
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative py-28 md:py-36 px-6 md:px-12 overflow-hidden"
    >
      <div className="absolute top-1/2 -left-32 w-[600px] h-[600px] rounded-full bg-[#c5a059]/5 blur-3xl pointer-events-none -translate-y-1/2" />

      <div className="max-w-7xl mx-auto relative">
        <div ref={ref} className="reveal max-w-3xl mb-16 md:mb-24">
          <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-6">
            01.5 · The Experience
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-tight">
            A boutique advisory,
            <br />
            <span className="italic gold-gradient">crafted around you</span>
          </h2>
          <p className="text-white/60 mt-6 leading-relaxed max-w-xl">
            Not a call centre. Not a listings marketplace. A senior-led property practice built
            around discretion, market intelligence and long-term client relationships.
          </p>
        </div>

        {/* Editorial triptych — alternating layout */}
        <div className="space-y-20 md:space-y-32">
          {IMAGES.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={item.tag}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-center"
                data-testid={`experience-frame-${idx}`}
              >
                {/* Image */}
                <div
                  className={`md:col-span-7 relative group ${
                    isEven ? "md:order-1" : "md:order-2"
                  }`}
                >
                  <div className="relative overflow-hidden rounded-2xl aspect-[16/9] md:aspect-[16/10]">
                    <img
                      src={item.src}
                      alt={item.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                    />
                    <div className="absolute inset-0 ring-1 ring-inset ring-[#c5a059]/20 rounded-2xl" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1128]/70 via-transparent to-transparent" />
                    <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between text-[10px] tracking-[0.35em] uppercase">
                      <span className="text-white/80">{item.tag}</span>
                      <span className="text-[#c5a059]">Universal Dream</span>
                    </div>
                  </div>

                  {/* Decorative offset frame */}
                  <div
                    className={`absolute -z-10 border border-[#c5a059]/25 rounded-2xl w-full h-full top-4 ${
                      isEven ? "-right-4" : "-left-4"
                    } hidden md:block`}
                  />
                </div>

                {/* Caption */}
                <div
                  className={`md:col-span-5 ${
                    isEven ? "md:order-2" : "md:order-1"
                  }`}
                >
                  <div className="text-[10px] tracking-[0.4em] text-[#c5a059] uppercase mb-4">
                    {item.tag}
                  </div>
                  <h3 className="font-serif-display text-3xl md:text-4xl leading-tight mb-5">
                    <em className="italic">{item.title}</em>
                  </h3>
                  <p className="text-white/65 leading-relaxed">{item.caption}</p>

                  <div className="mt-8 flex items-center gap-4">
                    <div className="h-px flex-1 bg-white/10" />
                    <span className="text-[10px] tracking-[0.4em] text-white/40 uppercase">
                      {String(idx + 1).padStart(2, "0")} / 03
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
